<div class="dropdown">
  <!-- Header -->
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">Notifications</div>
      <div class="dropdown-subheading">
        @if (loading) {
          Loading…
        } @else if (unreadCount > 0) {
          You have {{ unreadCount }} unread notification{{ unreadCount !== 1 ? 's' : '' }}.
        } @else {
          No new notifications.
        }
      </div>
    </div>

    <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button">
      <iconify-icon [icon]="icSettings" class="notifications-header-icon"></iconify-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dropdown-content">
    @if (loading) {
      <div class="flex items-center justify-center py-8 text-secondary">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    } @else if (notifications.length === 0) {
      <div class="flex items-center justify-center py-8 text-secondary">
        All caught up!
      </div>
    } @else {
      @for (notification of notifications; track trackById($index, notification)) {
        <a
          [class.read]="notification.read"
          (click)="markRead(notification)"
          class="notification flex items-center"
          matRipple>
          <iconify-icon
            [icon]="notification.icon"
            [ngClass]="notification.colorClass"
            class="notification-icon shrink-0"
            width="24"
            height="24">
          </iconify-icon>
          <div class="flex-1">
            <div class="notification-label">{{ notification.label }}</div>
            <div class="notification-description">{{ notification.description }}</div>
            <div class="notification-description">
              {{ notification.datetime | relativeDateTime }}
            </div>
          </div>
          <iconify-icon [icon]="icChevronRight" class="notification-chevron shrink-0"></iconify-icon>
        </a>
      }
    }
  </div>

  <!-- Footer -->
  <div class="dropdown-footer flex items-center justify-center">
    <button color="primary" mat-button type="button" (click)="markAllRead()">
      MARK ALL AS READ
    </button>
  </div>
</div>

<!-- Settings Menu -->
<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item (click)="markAllRead()">
    <iconify-icon [icon]="icClearAll"></iconify-icon>
    <span>Mark all as read</span>
  </button>

  <button mat-menu-item>
    <iconify-icon [icon]="icNotificationsOff"></iconify-icon>
    <span>Disable Notifications</span>
  </button>
</mat-menu>
